module.exports = __webpack_public_path__ + "static/media/pina-messina-qQKv7r1BaRw-unsplash.c648b92e.jpg";